/**
 * InPlace container — renders the ad inline in the page at the position of the
 * bootstrap <script> tag on-page or the current frame body when framed.
 *
 * This is the default container type. It applies no positioning styles — the ad
 * occupies its natural position in the document flow.
 *
 * renderLocation is always null — the caller falls back to resolveDefaultTarget.
 */
export class InPlaceContainer {
  /**
   * @param {object} _config    - unused for InPlace; present for interface consistency
   * @param {object} renderEnv  - captured render environment from getRenderEnv()
   */
  constructor(_config, renderEnv) {
    this._renderEnv = renderEnv;
  }

  /**
   * InPlace is always supported — it has no environmental requirements.
   * @returns {boolean}
   */
  isSupported() {
    return true;
  }

  /**
   * No positioning styles needed for inline flow.
   * @param {HTMLElement} _el
   */
  applyStyles(_el) {}

  /**
   * InPlace has no specific render location — the caller uses resolveDefaultTarget.
   * @returns {null}
   */
  get renderLocation() {
    return null;
  }
}
